import { Badge, badgeClasses, styled } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export type BadgePlacement = 'overlay' | 'inline';

export type StyledBadgeProps = {
  placement: BadgePlacement;
};

type BadgeSlotSxParams = StyledBadgeProps & {
  top?: string;
  right?: string;
};

const BADGE_SIZE = 20;
const OVERLAY_TRANSLATE = 'translate(25%, -50%)';

export function getBadgeSlotSx({ placement, top = '-1px', right = '0' }: BadgeSlotSxParams): SxProps<Theme> {
  if (placement === 'inline') {
    return {
      position: 'static',
      marginLeft: 0.5,
      transform: 'none',

      [`&.${badgeClasses.invisible}`]: {
        transform: 'scale(0)',
      },
    };
  }

  return {
    top,
    right,
    transformOrigin: 'top right',
    transform: OVERLAY_TRANSLATE,

    [`&.${badgeClasses.invisible}`]: {
      transform: `${OVERLAY_TRANSLATE} scale(0)`,
    },
  };
}

export const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'placement',
})<StyledBadgeProps>(({ theme, placement }) => ({
  ...(placement === 'inline' && {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 0,
    flex: 1,
  }),

  [`& .${badgeClasses.badge}`]: {
    minWidth: BADGE_SIZE,
    height: BADGE_SIZE,
    padding: theme.spacing(0, 0.5),
    borderRadius: BADGE_SIZE / 2,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    boxShadow: theme.shadows[2],
    fontSize: '0.7rem',
    fontWeight: 500,
    opacity: 0.9,
  },
}));
